// country && (params.CountriesWithCCPayment.indexOf(country.toLowerCase()) > -1 || LiquidSpaceConfig.SupportedCountries.indexOf(country.toLowerCase()) > -1 || country.toUpperCase() == 'GB'

import { ILocationViewModel } from "Services/API/API";
import { userSelector } from "Utils/selectors";

export const isSupportedCountry = (country: string) => {
   return (
      LiquidSpaceConfig.SupportedCountries.indexOf(country.toLowerCase()) >
         -1 || country.toUpperCase() == "GB"
   );
};

const REQUIRED_ADDRESS_COMPONENT_TYPES = [
   "administrative_area_level_2",
   "locality",
   "sublocality",
   "street_number",
   "route"
];

export const isValidLocation = (place: ILocationViewModel) => {
   const isFullAddress = place.addressComponents.some((component) =>
      component.types.some((type) =>
         REQUIRED_ADDRESS_COMPONENT_TYPES.includes(type)
      )
   );
   const isEstablishment = place.types?.includes("establishment");

   return isFullAddress || isEstablishment;
};

export const isAuthenticated = (userId?: string) => {
   const user = userSelector(LSStore.instance.getState());
   const actualUserId = userId ?? user.id;
   return Boolean(actualUserId && actualUserId !== Guid.Empty);
};

export const openSignUpPopUp = (
   onLogInSuccessCallback?: (userId?: string) => void
) => {
   LSHelper.Account.popUpSignIn({
      onlyHeaderReload: true,
      onLogInSuccessCallback,
      signInMessage: "Great! Let's get your space listed.",
      joinMessage: "Join the Largest Network for Office Space.",
      popupParams: {
         mode: "join",
         regType: LSCommon.Enums.RegistrationType.ShareYourSpace,
         sendSysEmail: true,
      },
   });
};

export const openConfirmVenueCreationPopup = (url: string, name: string) => {
   const linkElement = document.getElementById("createNewSpace");
   const nameElement = document.getElementsByClassName("confirm-venue-creation-fname");
   const containerElement = document.getElementById("confirmVenueCreation");
   const user = userSelector(LSStore.instance.getState());


   if(linkElement && nameElement && containerElement) {
      linkElement.setAttribute("href", url);
      nameElement[0].innerHTML = user?.firstName ?? "";
      containerElement.style.display = "block";
   }
};
